class EventStack {
    stack = {};
    add = (target, type, listener) => {
        if (!(target in this.stack)) {
            this.stack[target] = {};
        }
        if (!(type in this.stack[target])) {
            this.stack[target][type] = [];
        }
        if (this.stack[target][type].length > 0) {
            target.removeEventListener(type, this.stack[target][type][this.stack[target][type].length - 1]);
        }
        this.stack[target][type].push(listener);
        target.addEventListener(type, listener);
    };
    remove = (target, type, listener) => {
        if (target in this.stack) {
            if (type in this.stack[target]) {
                const count = this.stack[target][type].length;
                this.stack[target][type] = this.stack[target][type].reduce((acc, storedListener, idx) => {
                    if (storedListener !== listener) {
                        acc.push(storedListener);
                    }
                    else if (idx === count - 1) {
                        target.removeEventListener(type, storedListener);
                        if (acc.length > 0) {
                            target.addEventListener(type, acc[acc.length - 1]);
                        }
                    }
                    return acc;
                }, []);
            }
        }
    };
}
export default new EventStack();
